export default __webpack_public_path__ + "static/media/AG01.1.58c951e1.mp3";